(() => {
  const originals = new WeakMap();
  const selections = new WeakMap();
  const pages = new Map();
  async function resolveColor(group, color) {
    let first;
    for (let page = 1, total = 1; page <= total; page++) {
      const url = new URL(group.dataset.cardProductUrl, window.location.origin);
      url.searchParams.delete('variant');
      url.searchParams.delete('option_values');
      url.searchParams.set('section_id', 'card-color-variants');
      url.searchParams.set('page', page);
      const key = url.toString();
      if (!pages.has(key)) pages.set(key, fetch(key, { signal: AbortSignal.timeout(15000) }).then(async response => {
        if (!response.ok) throw new Error('Color could not be selected. Please try again.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = html.querySelector('[data-card-variants-json]');
        if (!data) throw new Error('Color could not be selected. Please try again.');
        return JSON.parse(data.textContent);
      }).catch(error => { pages.delete(key); throw error; }));
      const data = await pages.get(key);
      if (data.page !== page) throw new Error('Color could not be selected. Please try again.');
      total = data.pages;
      for (const variant of data.variants) {
        if (variant.options[Number(group.dataset.colorPosition) - 1] !== color) continue;
        first ||= variant;
        if (variant.available) return variant;
      }
    }
    if (!first) throw new Error('Color could not be selected. Please try again.');
    return first;
  }
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-card-color]');
    if (!button) return;
    event.preventDefault();
    const card = button.closest('.card-wrapper');
    if (!card) return;
    const group = button.closest('.card-color-swatches');
    const token = {};
    selections.set(card, token);
    const status = card.querySelector('[data-card-color-status]');
    if (status) status.textContent = '';
    if (group.dataset.paginatedVariants === 'true') {
      group.setAttribute('aria-busy', 'true');
      try {
        const variant = await resolveColor(group, button.dataset.colorName);
        if (selections.get(card) !== token) return;
        button.dataset.variantId = variant.id;
        ['imageSrc', 'imageSrcset', 'imageAlt', 'imageWidth', 'imageHeight'].forEach(key => {
          if (variant[key] == null) delete button.dataset[key];
          else button.dataset[key] = variant[key];
        });
      } catch (error) {
        if (selections.get(card) === token && status) status.textContent = error.message;
        return;
      } finally {
        if (selections.get(card) === token) group.removeAttribute('aria-busy');
      }
    }
    const image = card.querySelector('.card__media .media > img');
    if (image) {
      const attributes = ['src', 'srcset', 'alt', 'width', 'height'];
      if (!originals.has(image)) originals.set(image, Object.fromEntries(attributes.map(key => [key, image.getAttribute(key)])));
      const original = originals.get(image);
      attributes.forEach((key) => {
        const property = 'image' + key[0].toUpperCase() + key.slice(1);
        const value = button.dataset.imageSrc ? button.dataset[property] : original[key];
        if (value == null) image.removeAttribute(key);
        else image.setAttribute(key, value);
      });
    }
    card.classList.toggle('card--color-selected', Boolean(button.dataset.imageSrc));
    card.querySelectorAll('[data-card-color]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    if (button.dataset.variantId) {
      card.querySelectorAll('.card__heading a, [data-product-url]').forEach((element) => {
        const attribute = element.hasAttribute('data-product-url') ? 'data-product-url' : 'href';
        const url = new URL(element.getAttribute(attribute), window.location.origin);
        url.searchParams.set('variant', button.dataset.variantId);
        element.setAttribute(attribute, url.pathname + url.search + url.hash);
      });
    }
  });
})();
